/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
import getEnvironment from '../../utils/getEnvironment';
import MarkerRedIcon from '../../assets/mapMarkers/MarkerRed.png';
import MarkerGreenIcon from '../../assets/mapMarkers/MarkerGreen.png';
import MarkerGrayIcon from '../../assets/mapMarkers/MarkerGray.png';
import { useEffect, useState } from 'react';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { createUseStyles } from 'react-jss';

const env = getEnvironment();

let apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_DEV;
if (env === 'production') {
  apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_PROD;
} else if (env === 'test') {
  apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_TEST;
}

const zoom = 4.5;
const center = { lat: 24.367113562651, lng: 80.68359375 };

const eventsMapping = {
  onCenterChanged: ['center_changed', (mapp) => mapp.getCenter()],
  onBoundsChangerd: ['bounds_changed', (mapp) => mapp.getBounds()],
};

const useStyles = createUseStyles({
  markerLabel: {
    textShadow:
      '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff',
  },
});

export default function JoulepointMap({ records = [] }) {
  // eslint-disable-next-line no-unused-vars
  const [bound, setBound] = useState({});
  const [chargersData, setChargersData] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    setChargersData([]);
    const geoformattedData = records?.map((record) => ({
      geometry: {
        type: 'Point',
        coordinates: [
          Number(record.COORDS.split(',')[0]),
          Number(record.COORDS.split(',')[1]),
        ],
      },
      active: !!record?.IS_AVAILABLE,
      name: record?.NAME,
    }));

    setTimeout(() => {
      setChargersData(geoformattedData);
    }, 500);
  }, [records]);

  useEffect(() => {
    const events = { onBoundsChangerd: (arg) => setBound(arg) };
    window.initMap = GoogleMapsApiLoader({ apiKey }).then((google) => {
      const map = new google.maps.Map(document.getElementById('chargers-map'), {
        zoom,
        center,
        minZoom: zoom - 2,
        fullscreenControl: true,
        gestureHandling: 'cooperative',
      });
      Object.keys(events).forEach((eventName) =>
        map.addListener(eventsMapping[eventName][0], () =>
          events[eventName](eventsMapping[eventName][1](map)),
        ),
      );

      const markers = chargersData.map((data, i) => {
        const label = data?.name;
        const marker = new google.maps.Marker({
          position: {
            lat: data?.geometry.coordinates[0],
            lng: data?.geometry.coordinates[1],
          },
          label: {
            text: label,
            fontWeight: '700',
            fontSize: '13px',
            className: classes.markerLabel,
          },
          extra: {
            active: data?.active,
          },
          icon: {
            url: data?.active ? MarkerGreenIcon : MarkerGrayIcon,
            scaledSize: new google.maps.Size(24, 30),
            labelOrigin: { x: 12, y: -10 },
          },
        });
        return marker;
      });

      new MarkerClusterer({
        markers,
        map,
        renderer: {
          render: ({ count, position, markers: markerss }, cd) => {
            const canvasId = `marker${Math.random()}`;
            const canvasId2 = `marker${Math.random() + 1}`;
            const clusterN = document.createElement('canvas');
            const clusterN2 = document.createElement('canvas');

            const activeChargers = markerss.filter(
              (markerr) => markerr?.extra?.active,
            );
            const activeChargersCount = activeChargers.length;
            const strokeActiveChargersEndpoint =
              ((2 * Math.PI) / count) * activeChargersCount;
            clusterN.setAttribute('id', canvasId);
            clusterN2.setAttribute('id', canvasId2);
            clusterN2.setAttribute('height', 190);
            clusterN.setAttribute('height', 180);
            const context = clusterN.getContext('2d');
            const context2 = clusterN2.getContext('2d');
            const centerX = clusterN.width / 2;
            const centerY = clusterN.height / 2;
            const radius = 50;
            context2.beginPath();
            context2.arc(
              centerX,
              centerY,
              radius,
              0,
              ((2 * Math.PI) / count) * activeChargersCount,
              false,
            );
            context2.lineWidth = 44;
            context2.strokeStyle = '#0DAC50';
            context2.stroke();

            // Grey
            context.beginPath();
            context.arc(
              centerX,
              centerY,
              radius,
              strokeActiveChargersEndpoint,
              2 * Math.PI,
              false,
            );
            context.lineWidth = 44;
            context.strokeStyle = 'grey';
            context.stroke();
            context2.fillStyle = 'white';
            context2.fill();
            context.fillStyle = 'white';
            context.fill();
            context.drawImage(clusterN2, 0, 0);

            const dataURL = clusterN.toDataURL();
            return new google.maps.Marker({
              label: {
                text: String(count),
                color: 'black',
                fontSize: '14px',
                fontWeight: '800',
              },
              position,
              // adjust zIndex to be above other markers
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              icon: {
                url: dataURL,
                scaledSize: new google.maps.Size(105, 60),
                // `data:image/svg+xml;base64,${svg}`
              },
            });
          },
        },
      });
    });
  }, [chargersData, classes.markerLabel]);
  return (
    <>
      <div id="chargers-map" style={{ height: '550px' }} />
    </>
  );
}
